<mat-card appearance="raised">
  <mat-card-content class="mat-card-content-lg">
    <div class="cointainer">
      <div class="content">
        <ifc-avatar-icon class="content__avatar"
                         [data]="data?.avatar"></ifc-avatar-icon>
        <div class="text">
          <div class="title">
            <span class="title__name">{{ data?.fullName }}</span>
            <span class="title__description">Business Advisor</span>
          </div>
          <div class="contact-data">
            <span>{{ data?.email }}</span>
            <span *ngIf="teamContactEmail">{{ teamContactEmail }}</span>
            <span>{{ data?.phone | phone }}</span>
          </div>
        </div>
      </div>
      <button *ngIf="servicingAdvisors && canEditAdvisor"
              mat-icon-button
              (click)="editAdvisor()"
              aria-label="Edit">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </mat-card-content>
</mat-card>
